"use client";

import type { ReactNode } from 'react';

export function BaseUiProvider({ children }: { children: ReactNode }) {
  return children;
}
